import '../src/css/App.css'
import Routes from './routes/Routes'
import { BrowserRouter } from 'react-router'
import ThemeProvider from './theme'

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <Routes />
      </ThemeProvider>
    </BrowserRouter>
  )
}

export default App
